import * as React from "react";

import { PlotLoadingState } from "../messaging/events";

const LOADING_LONG_THRESHOLD_MS = 5000;

/**
 * Identify when data loads are taking a while to signal
 * that a loading indicator should be used.
 */
export function useShowBackgroundLoading(
  isPlotLoading: PlotLoadingState,
): boolean {
  const [showBackgroundLoading, setShowBackgroundLoading] =
    React.useState(false);
  const longLoadingTimeout = React.useRef<number>();
  React.useEffect(
    function showBackgroundLoadingIndicator() {
      // Clear any existing long loading timeout and loading indicator
      // when the loading state changes.
      clearTimeout(longLoadingTimeout.current);
      setShowBackgroundLoading(false);
      // Enable the background loading indicator after the background loading stage
      // takes at least the given duration.
      if (isPlotLoading === "background") {
        longLoadingTimeout.current = window.setTimeout(() => {
          setShowBackgroundLoading(true);
        }, LOADING_LONG_THRESHOLD_MS);
      }
      return function cleanUp() {
        clearTimeout(longLoadingTimeout.current);
      };
    },
    [isPlotLoading],
  );
  return isPlotLoading === "background" && showBackgroundLoading;
}
